import pigImg from './assets/pig.svg';
import keyImg from './assets/key.svg';
import houseImg from './assets/house.svg';

export const ADVANTAGES_CONTENT = [
  {
    title: (
      <>
        Определиться <br /> с будущим
      </>
    ),
    text: 'Узнайте, за сколько и как быстро можно продать жильё — и какое подойдёт взамен',
    imgUrl: pigImg,
    className: 'pig',
  },
  {
    title: (
      <>
        Сдать квартиру <br /> выгодно
      </>
    ),
    text: 'Доход от аренды, спрос на рынке — знаем всё, что полезно собственникам',
    imgUrl: keyImg,
    className: 'key',
  },
  {
    title: 'Решить, что делать с загородным жильём',
    text: 'Трехэтажный особняк, бабушкина дача или участок — расскажем обо всём',
    imgUrl: houseImg,
    className: 'house',
  },
];
